import { useQuery } from '@tanstack/react-query'
import { buildQuery, useApi } from './client'
import type { MovementResponse, TransactionType } from './types'

export type MovementFilters = {
  dateFrom: string
  dateTo: string
  type?: TransactionType
  categoryIds?: string[]
  projectIds?: string[]
  tagIds?: string[]
  search?: string
}

function filtersKey(f: MovementFilters) {
  return {
    dateFrom: f.dateFrom,
    dateTo: f.dateTo,
    type: f.type ?? null,
    categoryIds: [...(f.categoryIds ?? [])].sort(),
    projectIds: [...(f.projectIds ?? [])].sort(),
    tagIds: [...(f.tagIds ?? [])].sort(),
    search: f.search ?? null,
  }
}

export function useAccountMovement(accountId: string | null, filters: MovementFilters) {
  const api = useApi()
  const key = filtersKey(filters)
  return useQuery({
    queryKey: ['account-movement', accountId, key],
    enabled: !!accountId,
    queryFn: () => {
      const query = buildQuery({
        date_from: filters.dateFrom,
        date_to: filters.dateTo,
        type: filters.type,
        search: filters.search,
      })
      const multi: string[] = []
      for (const id of key.categoryIds) multi.push(`category_id=${encodeURIComponent(id)}`)
      for (const id of key.projectIds) multi.push(`project_id=${encodeURIComponent(id)}`)
      for (const id of key.tagIds) multi.push(`tag_id=${encodeURIComponent(id)}`)
      const path =
        `/accounts/${accountId}/movement${query}` +
        (multi.length ? (query ? '&' : '?') + multi.join('&') : '')
      return api<MovementResponse>(path)
    },
  })
}
